import axios from 'axios'
import { postWithoutTokenFunciton,getFunciton } from 'utils/ApiHelper'
import { AccountModel , PointModel } from '../models/Account'

export async function getListGmailAccount(com:string, params: any = {}) {
  const res:any = await postWithoutTokenFunciton("gmail/listPaginate?computer=" + com, params)
  return res
}

export async function getListAccountCom(data: any) {
  const res:any = await postWithoutTokenFunciton("gmail/computer/list", data)
  return res
}

export async function getListGroupByCom(server: string) {
  const res:any = await getFunciton("gmail/group?computer=" + server);
  return res
}

export async function deleteMusicTheme(theme: string) {
  const res:any = await getFunciton("gmail/music-theme/delete/" + theme);
  return res
}

export async function deleteMusicGroup(group: string) {
  const res:any = await getFunciton("gmail/group/delete/" + group);
  return res
}

export async function fetchListMusicTheme(server: string) {
  const res:any = await getFunciton("gmail/music-theme?computer=" + server);
  return res;
}

export async function updateChannelInfoGeneral(email: string, data: object) {
  const res: any = await postWithoutTokenFunciton(`gmail/update/info/${email}`, data);
  return res;
}

export async function addNewComputerUpload(data: any = {}) {
  const res:any = await postWithoutTokenFunciton("computer/make", data);
  return res
}

export async function addNewGmail(data: any = {})  {
  const res: any = await postWithoutTokenFunciton("gmail/add", data);
  return res;
} 

export async function refreshAccount() {
  const res:any = await getFunciton("gmail/refresh")
  return res
}

export async function deleteAccount(username:string) {
  const res:any = await getFunciton("gmail/delete/"+username)
  return res
}

export async function deleteProxy(ip:String) {
  const res:any = await getFunciton("api/proxy/delete?ip="+ip)
  return res
}



export async function refreshAccountInfo() {
  const res:any = await getFunciton("/account/refreshData")
  return res
}
export async function refreshViewSub() {
  const res:any = await getFunciton("/account/refreshViewSub")
  return res
}

export async function addProxies(ips:String) {
  const data= ips.split("\n").map(item=>{
    return {
      proxy:item
    }
  })
  const res:any = await postWithoutTokenFunciton(`proxy/create`,data)
  return res
}


export async function getListBiliChannelOfUser(username:string) {
  const res:any = await getFunciton(`bili/list/${username}`)
  return res
}

export async function exportVideoUploaded(username: any, data: any) {
  const res:any = await postWithoutTokenFunciton(`export/video-uploaded/multiple?user=${username}`, data);
  return res;
}

export async function exportChannelByServer(com: any, data: any) {
  const res:any = await postWithoutTokenFunciton(`export/group-channel?computer=` + com, data);
  return res
}

export async function downloadFilePublic(file_name: any) {
  const res: any = await getFunciton(`/download-public?file=${file_name}`);
  return res;
}

export async function chartInfoSingleChannel(username:string, data: any) {
  const res:any = await postWithoutTokenFunciton(`/chart/gmail/single/${username}`, data);
  return res
}

export async function chartInfoServerChannel(server:string, data: any) {
  const res:any = await postWithoutTokenFunciton(`/chart/gmail/server?computer=${server}`, data);
  return res
}

export async function countVideoUploadStatistic(server:string, data: any) {
  const res:any = await postWithoutTokenFunciton(`chart/video-upload?computer=${server}`, data);
  return res
}

export async function getListVerifyByUsername(username:string) {
  const res:any = await getFunciton(`gmail/verify/list/${username}`)
  return res
}

export async function getDetailChannel(username:string) {
  const res:any = await getFunciton(`gmail/detail/${username}`)
  return res
}


export async function deleteBiliSpace(mid:number) {
  const res:any = await getFunciton(`/bili/delete/${mid}`)
  return res
}


export async function nextBiliVideo(video_id:string) {
  const res:any = await getFunciton(`/bili/videos/next/${video_id}`)
  return res
}

export async function unmarkBiliSpace(mid:number,username:string) {
  const res:any = await getFunciton(`/bilis/unmark?mid=${mid}&username=${username}`)
  return res
}

export async function reScanDataVideo(mid:number,user_id:string) {
  const res:any = await getFunciton(`/bili/scan/${mid}`)
  return res
}

export async function getListVideoOfSpace(mid:number) {
  const res:any = await getFunciton(`/bili/videos/${mid}`)
  return res
}
